export default { sha: '8ceccf93361465f7c3ebbc5c5877a803cae7a66f', buildNumber: 'undefined' }
